import React, { useState } from 'react';
import { BuySellAdjustmentTableContext, IBuySellAdjustmentTableContext } from './BuySellAdjustmentTableContext';
import { useAsyncData } from '@shared/react';
import { usePagination2 } from '@features/Pagination/usePagination';
import { getLogo } from '@widgets/TransactionsTable/api';
import { userRebalancing } from '@widgets/BuySellAdjustmentTable/api';

export interface ITransactionDesc {
    id: boolean;
    accountId: boolean;
    orderId: boolean;
    date: boolean;
    price: boolean;
    settlementDate: boolean;
    quantity: boolean;
    type: boolean;
    execId: boolean;
    processed: boolean;
    [key: string]: boolean;
}

export const BuySellAdjustmentTableProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [accountId, setAccountId] = useState<any>(null);
    const [sortFieldName, setSortFieldName] = useState('id');

    const [desc, setDesc] = useState<ITransactionDesc>({
        id: true,
        accountId: true,
        orderId: true,
        date: true,
        price: true,
        settlementDate: true,
        quantity: true,
        type: true,
        execId: true,
        processed: true,
    });

    const { page, pageSize, setTotalCount, paginationOptions } = usePagination2();

    const { data: AssignPositionBody, loading: holdingLoading } = useAsyncData(
        async () => {
            if (accountId !== null) {
                const items = await userRebalancing(accountId);
                const startIndex = (page - 1) * pageSize;
                const endIndex = startIndex + pageSize;

                const paginatedItems = items?.slice(startIndex, endIndex) || [];

                setTotalCount(items?.length || 0);

                return paginatedItems;
            } else {
                return [];
            }
        },
        [],
        [pageSize, page, accountId],
    );

    const { data: arrayWithLogos, loading: logoLoading } = useAsyncData(
        async () => {
            if (!AssignPositionBody) return [];
            return await Promise.all(
                AssignPositionBody.map(async (item: any) => {
                    const res = await getLogo({ symbol: item.symbol });
                    return { link: res, symbol: item.symbol };
                }),
            );
        },
        [],
        [AssignPositionBody],
    );

    const value: IBuySellAdjustmentTableContext = {
        AssignPositionBody: AssignPositionBody ?? [],
        paginationOptions,
        arrayWithLogos,
        holdingLoading,
        sortFieldName,
        desc,
        setAccountId,
    };

    return <BuySellAdjustmentTableContext.Provider value={value}>{children}</BuySellAdjustmentTableContext.Provider>;
};
